// extracted by mini-css-extract-plugin
module.exports = {"box":"box--111zC","titMod":"titMod--oQuhp","tit":"tit--iElWY"};